import React from 'react';
import PropTypes from 'prop-types';
import { VerticalSpacingWrapper } from './VerticalSpacing.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

const SIZES = ['lg', 'sm', 'xs'];

function VerticalSpacing(props) {
  const { children, size, type } = props;

  return (
    <VerticalSpacingWrapper size={size} type={type}>
      {children}
    </VerticalSpacingWrapper>
  );
}

VerticalSpacing.propTypes = {
  /** This can be anything, a string, component etc. */
  children: ReactChildrenPropType,
  /** Pick size of spacing you want to use. Current options are: lg, sm */
  size: PropTypes.oneOf(SIZES),
  /** Type of spacing you want to use */
  type: PropTypes.oneOf(['padding', 'margin'])
};

VerticalSpacing.defaultProps = {
  size: 'lg',
  type: 'padding',
  children: null
};

export default VerticalSpacing;
